<template>
  <div class="content">
    <div class="forms">
      <!-- PERSONA FÍSICA -->
      <div class="p-fluid">
        <div>
          <div
            class="flex flex-wrap justify-content-start align-items-end gap-3"
            style="width: 100%; margin-left: 0; box-sizing: border-box"
          >
            <div
              class="field condition"
              test-id="buttonTipoDenunciante"
              style="flex: 0 0 auto; width: 28rem"
            >
              <label for="tipoDocumento" class="labelInput">
                Tipo de {{ props.personType === "affected" ? "afectado" : "vinculado" }}
                <span style="color: red">*</span></label
              >
              <Dropdown
                dataKey="nombre"
                v-model="person.TipoRolPersonaFisicaID"
                :options="
                  person.allPersonConditions[
                    viewData?.formPersona?.condition?.[
                      props.personType === 'vinculated' ? 'acusados' : 'denunciante'
                    ]
                  ]
                "
                optionLabel="nombre"
                :placeholder="`Tipo de ${
                  props.personType === 'affected' ? 'afectado' : 'vinculado'
                }`"
                class="input"
                test-id="InputTipoDenunciante"
                :filter="
                  Array.isArray(
                    person.allPersonConditions[
                      viewData?.formPersona?.condition?.[
                        props.personType === 'vinculated' ? 'acusados' : 'denunciante'
                      ]
                    ]
                  ) &&
                  person.allPersonConditions[
                    viewData?.formPersona?.condition?.[
                      props.personType === 'vinculated' ? 'acusados' : 'denunciante'
                    ]
                  ].length >= 5
                "
                :disabled="props.isDisable || ordenPublico || filiacionDesconocida"
              />
            </div>
            <div style="flex: 0 0 auto; width: 0"></div>
            <div
              v-if="!isADeterminar"
              class="flex align-items-end justify-content-start gap-3"
              style="flex: 0 0 auto; width: 12rem"
            >
              <div
                class="field-checkbox flex align-items-center justify-content-start"
                test-id="divPersonaJuridica"
              >
                <Checkbox
                  id="persona-juridica"
                  v-model="juridicPerson"
                  :disabled="props.isDisable || ordenPublico || filiacionDesconocida"
                  :binary="true"
                  test-id="checkPersonaJuridica"
                />
                <label class="labelInput white-space-nowrap" for="persona-juridica">
                  <b>¿Es Persona Jurídica?</b>
                </label>
              </div>

              <div
                class="field-checkbox flex align-items-center justify-content-start ml-3"
                test-id="checkFilacionDesconocida"
                v-if="props.personType !== 'affected'"
              >
                <Checkbox
                  id="binary"
                  v-model="filiacionDesconocida"
                  :binary="true"
                  :disabled="props.isDisable || isDetenidoCondition"
                />
                <CustomTooltip
                  v-if="isDetenidoCondition"
                  :text="detenidoFiliacionTooltip"
                  placement="bottom"
                  class="ml-2"
                >
                  <label
                    for="binary"
                    class="labelInput white-space-nowrap filiacion-disabled-label"
                  >
                    <b>Filiación Desconocida</b>
                  </label>
                </CustomTooltip>
                <label v-else for="binary" class="labelInput white-space-nowrap">
                  <b>Filiación Desconocida</b>
                </label>
              </div>
              <div
                class="field-checkbox flex align-items-center justify-content-start ml-3"
                test-id="checkOrdenPublico"
                v-if="showOrdenPublico"
              >
                <Checkbox
                  id="binary"
                  v-model="ordenPublico"
                  :binary="true"
                  :disabled="props.isDisable"
                />
                <label for="binary" class="labelInput white-space-nowrap">
                  <b>Orden Público</b>
                </label>
              </div>
            </div>
          </div>
        </div>

        <div v-if="!filiacionDesconocida && !ordenPublico && !isADeterminar && props.isCreate">
          <div
            class="flex flex-wrap justify-content-start align-items-end mb-4"
            style="width: 100%; margin-left: 0; box-sizing: border-box"
          >
            <label class="custom-radio ml-4">
              <input
                type="radio"
                name="modo"
                :value="false"
                v-model="isSipeMode"
                :disabled="props.isDisable"
              />
              <span class="radio"></span>
              Ingreso Manual
            </label>

            <label class="custom-radio">
              <input
                type="radio"
                name="modo"
                :value="true"
                v-model="isSipeMode"
                :disabled="props.isDisable || isEdit"
              />
              <span class="radio"></span>
              Búsqueda SIPE
            </label>
          </div>
        </div>

        <SearchModuleSIPE
          :personType="props.personType"
          :personData="props.personData"
          :isDisable="props.isDisable"
          @updateFormPersona="(value) => updateFormPersonaV2(value)"
          @setIsDisabled="(value) => setIsDisabled(value)"
          @callToSIPEsearchUsed="(value) => callToSIPEsearchUsed(value)"
          :SIPEsearchUsed="SIPEsearchUsed"
          v-if="isSipeMode && !isADeterminar && !ordenPublico"
        />

        <div v-if="!filiacionDesconocida && !ordenPublico && !isADeterminar">
          <div class="grid gap-5 mt-2" style="width: 100%" v-if="!isSipeMode">
            <div
              class="field grid m-0!"
              style="
                width: 100%;
                margin-left: 0.1px;
                margin-bottom: 0 !important;
                margin: 0 !important;
              "
            >
              <div class="field col-4 mb-0!" style="margin-bottom: 0 !important">
                <label for="tipoDocumento" class="labelInput flex align-items-center">
                  Tipo de identificación
                  <span v-if="props.personType === 'affected'" style="color: red">*</span>
                </label>
                <Dropdown
                  id="tipoIdentificacion"
                  class="input w-full mt-2"
                  :options="tipoDocumentoList"
                  placeholder="Tipo de identificación"
                  optionLabel="nombre"
                  dataKey="id"
                  v-model="documentType"
                  :disabled="props.isDisable"
                  test-id="inputDniDenunciante"
                  :showClear="!props.isDisable && props.personType !== 'affected'"
                />
                <div class="error-slot">
                  <label v-if="modifiedData.documento && errores.tipoDocumento" class="error-field">
                    {{ errores.tipoDocumento }}
                  </label>
                </div>
              </div>

              <div class="field col-4" style="margin-bottom: 0 !important">
                <label for="documento" class="labelInput flex align-items-center">
                  Número de Identificación
                  <span v-if="props.personType === 'affected'" style="color: red">*</span>
                </label>
                <InputText
                  v-no-emoji
                  class="input w-full"
                  type="text"
                  v-model="documentNumber"
                  :maxlength="50"
                  :disabled="props.isDisable"
                  placeholder="Número de Identificación"
                  test-id="inputDniDenunciante"
                />
                <div class="error-slot">
                  <label
                    v-if="modifiedData.documento && errores.documento && !props.isDisable"
                    class="error-field"
                  >
                    {{ errores.documento }}
                  </label>
                </div>
              </div>

              <div class="field col-4" :style="stylesFor720" style="margin-bottom: 0 !important">
                <label for="sexo" class="labelInput flex align-items-center">
                  Sexo
                  <span v-if="props.personType === 'affected'" style="color: red">*</span>
                </label>
                <Dropdown
                  class="input w-full"
                  dataKey="nombre"
                  v-model="person.gender"
                  placeholder="Sexo"
                  :options="sexoList"
                  optionLabel="nombre"
                  :filter="sexoList?.length >= 5"
                  :disabled="props.isDisable"
                  ref="genderRef"
                />
              </div>
            </div>
          </div>
          <div>
            <div
              class="flex flex-wrap align-items-end justify-content-start w-full mt-3 gap-3"
              style="margin-left: 0; box-sizing: border-box"
            >
              <div>
                <p
                  class="field p-error col-12 mt-0 pt-0"
                  test-id="sipeLabelError"
                  v-if="props?.personData?.error"
                >
                  {{ props?.personData?.error }}
                </p>
              </div>
              <div class="p-fluid formgrid grid -mt-2" style="width: 100%; margin: 0">
                <div class="grid" style="width: 100%; margin: 0">
                  <div class="field col-4" test-id="inputApellido" style="padding-left: 0">
                    <label for="apellido" class="labelInput"
                      >Apellido
                      <span v-if="props.personType === 'affected'" style="color: red"
                        >*</span
                      ></label
                    >
                    <InputText
                      v-no-emoji
                      class="input"
                      type="text"
                      placeholder="Apellido/s"
                      :maxlength="50"
                      v-model="surname"
                      :disabled="props.isDisable || SIPEsearchUsed"
                    />
                    <label v-if="modifiedData.apellido" :class="{ visible: errores.apellido }">
                      {{ errores.apellido }}
                    </label>
                  </div>

                  <div class="field col-5" test-id="inputNombre">
                    <label for="nombre" class="labelInput"
                      >Nombre
                      <span v-if="props.personType === 'affected'" style="color: red"
                        >*</span
                      ></label
                    >
                    <InputText
                      v-no-emoji
                      class="input"
                      type="text"
                      placeholder="Nombre"
                      v-model="name"
                      :maxlength="50"
                      :disabled="props.isDisable || SIPEsearchUsed"
                    />
                    <label v-if="modifiedData.nombre" :class="{ visible: errores.nombre }">
                      {{ errores.nombre }}
                    </label>
                  </div>

                  <div class="field col-3">
                    <label for="edad" class="labelInput">Edad </label>
                    <InputText
                      v-no-emoji
                      class="input"
                      type="number"
                      placeholder="Edad"
                      v-model="yearOld"
                      :disabled="true"
                    />
                    <label v-if="modifiedData.edad" :class="{ visible: errores.edad }">
                      {{ errores.edad }}
                    </label>
                  </div>
                </div>

                <div
                  class="grid flex flex-wrap justify-content-start align-items-end"
                  style="width: 100%; margin: 0"
                >
                  <div class="field col-4" test-id="inputFechaNac" style="padding-left: 0">
                    <label for="fechaNacimiento" class="labelInput flex align-items-center"
                      >Fecha de nacimiento
                      <span v-if="props.personType === 'affected'" style="color: red"
                        >*</span
                      ></label
                    >
                    <InputMask
                      v-no-emoji
                      class="input"
                      type="birthDate"
                      mask="99/99/9999"
                      v-model="birthday"
                      placeholder="dd/mm/yyyy"
                      :disabled="props.isDisable || SIPEsearchUsed"
                      slotChar="_"
                      @input="onBirthdayInteraction"
                      @blur="onBirthdayInteraction"
                      @complete="onBirthdayInteraction"
                    />
                    <div class="error-slot">
                      <label
                        v-if="modifiedData.fechaNacimiento && errores.FechaDeNacimiento"
                        class="error-field"
                      >
                        {{ errores.FechaDeNacimiento }}
                      </label>
                    </div>
                  </div>

                  <div class="field col-5" test-id="buttonNacionalidad">
                    <label for="nacionalidad" class="labelInput"
                      >Nacionalidad
                      <span v-if="props.personType === 'affected'" style="color: red"
                        >*</span
                      ></label
                    >
                    <Dropdown
                      class="input"
                      dataKey="nombre"
                      v-model="person.nacionality"
                      placeholder="Nacionalidad"
                      :options="nacionalityList"
                      optionLabel="nombre"
                      :filter="nacionalityList?.length >= 5"
                      :disabled="props.isDisable"
                    />
                    <div class="error-slot"></div>
                  </div>

                  <div class="field col-3">
                    <label for="cuil" class="labelInput flex align-items-center">
                      Número de Cuil
                    </label>
                    <InputText
                      v-no-emoji
                      class="input w-full"
                      v-model="cuil"
                      placeholder="N° de Cuil."
                      :disabled="props.isDisable"
                    />
                    <div class="error-slot">
                      <label v-if="modifiedData.Cuil" :class="{ visible: errores.Cuil }" class="error-field">
                        {{ errores.Cuil }}
                      </label>
                    </div>
                  </div>
                </div>

                <div
                  class="grid mb-3 flex flex-wrap justify-content-start align-items-end"
                  style="width: 100%; margin: 0"
                >
                  <div class="field col-9" style="padding-left: 0" test-id="textareaDomDeclarado">
                    <label for="residenciaSIPE" class="labelInput"
                      >Domicilio
                      <span v-if="props.personType === 'affected'" style="color: red"
                        >*</span
                      ></label
                    >
                    <InputText
                      v-no-emoji
                      class="input w-full"
                      type="text"
                      placeholder="Domicilio"
                      v-model="domicile"
                      :maxlength="100"
                      :disabled="props.isDisable"
                    />
                    <label
                      v-if="modifiedData.DomicilioSipe"
                      :class="{ visible: errores.DomicilioSipe }"
                    >
                      {{ errores.DomicilioSipe }}
                    </label>
                  </div>

                  <div class="field col-3 mt-2">
                    <label for="exhibeDocumento" class="labelInput">
                      ¿Exhibe el documento?
                      <span v-if="props.personType === 'affected'" style="color: red">*</span>
                    </label>
                    <Dropdown
                      class="input w-full"
                      dataKey="id"
                      v-model="person.showDocument"
                      placeholder="¿Exhibe el documento?"
                      :options="yesOrNoList"
                      optionLabel="nombre"
                      test-id="buttonExhibeDocumento"
                      :disabled="props.isDisable"
                    />
                  </div>
                </div>

                <div class="w-full -mt-2">
                  <div
                    class="field"
                    v-if="props.personType === 'affected'"
                    style="padding: 0 0 1em 0; max-width: 38.6rem"
                  >
                    <label for="vinculo" class="labelInput">Vínculo con la víctima</label>
                    <InputText
                      v-no-emoji
                      class="input"
                      type="text"
                      placeholder="Vínculo con la víctima"
                      v-model="props.personData.Vinculo"
                      :maxlength="50"
                      test-id="inputVinculo"
                      :disabled="props.isDisable"
                    />
                    <label v-if="modifiedData.vinculo" :class="{ visible: errores.Vinculo }">
                      {{ errores.Vinculo }}
                    </label>
                  </div>
                </div>

                <div class="grid mb-3" style="width: 100%">
                  <div class="field col-4">
                    <label for="telefono" class="labelInput">
                      Teléfono
                      <span v-if="props.personType === 'affected'" style="color: red">*</span>
                    </label>
                    <InputText
                      v-no-emoji
                      class="input w-full"
                      type="text"
                      min="10000000"
                      max="999999999"
                      placeholder="Número de teléfono"
                      v-model="telephone"
                      :maxlength="20"
                      :disabled="props.isDisable"
                      test-id="inputTel"
                      ref="telephoneInput"
                    />
                    <label v-if="modifiedData.telefono" :class="{ visible: errores.Telefono }">
                      {{ errores.Telefono }}
                    </label>
                  </div>

                  <div class="field col-4">
                    <label for="emailInput" class="labelInput">
                      Email
                      <span v-if="props.personType === 'affected'" style="color: red">*</span>
                    </label>
                    <InputText
                      v-no-emoji
                      class="input w-full"
                      placeholder="Email"
                      v-model="email"
                      :maxlength="50"
                      :disabled="props.isDisable"
                      test-id="inputEmail"
                      id="emailInput"
                    />
                    <div class="error-slot">
                      <label v-if="emailErrors !== ''" class="error-field">
                        {{ emailErrors }}
                      </label>
                    </div>
                  </div>

                  <div class="field col-4">
                    <label for="profesion" class="labelInput">
                      Profesión
                      <span v-if="props.personType === 'affected'" style="color: red">*</span>
                    </label>
                    <InputText
                      v-no-emoji
                      class="input w-full"
                      placeholder="Profesión"
                      v-model="profession"
                      :maxlength="45"
                      :disabled="props.isDisable"
                      test-id="inputProfesion"
                    />
                    <label v-if="modifiedData.profesion" :class="{ visible: errores.Profesion }">
                      {{ errores.Profesion }}
                    </label>
                  </div>
                </div>

                <!-- <div class="w-full mt-2" style="width: 100%; box-sizing: border-box">
              <div class="flex flex-wrap align-items-start justify-content-start gap-3"></div>
            </div> -->
                <div class="grid" style="width: 100%">
                  <div class="field col-4">
                    <label for="tieneEstudios" class="labelInput mb-2">
                      ¿Tiene estudio?
                      <span v-if="props.personType === 'affected'" style="color: red">*</span>
                    </label>
                    <Dropdown
                      class="input w-full"
                      dataKey="id"
                      v-model="person.haveStudies"
                      placeholder="¿Tiene estudios?"
                      :options="yesOrNoList"
                      optionLabel="nombre"
                      :filter="false"
                      test-id="buttonTieneEstudios"
                      :disabled="props.isDisable"
                    />
                  </div>

                  <div class="field col-4">
                    <label for="instruccion" class="labelInput">
                      Instrucción
                      <span v-if="props.personType === 'affected'" style="color: red">*</span>
                    </label>
                    <Dropdown
                      class="input w-full"
                      dataKey="nombre"
                      v-model="person.instruction"
                      placeholder="Instrucción"
                      :options="instruccionList"
                      optionLabel="nombre"
                      :filter="instruccionList?.length >= 5"
                      test-id="buttonInstruccion"
                      :disabled="props.isDisable"
                    />
                  </div>

                  <div class="field col-4" test-id="buttonEstadoCivil">
                    <label for="estadoCivil" class="labelInput"
                      >Estado civil
                      <span v-if="props.personType === 'affected'" style="color: red"
                        >*</span
                      ></label
                    >
                    <Dropdown
                      dataKey="nombre"
                      class="input"
                      v-model="person.civilStatus"
                      placeholder="Estado civil"
                      :options="civilStatusList"
                      optionLabel="nombre"
                      :filter="civilStatusList?.length >= 5"
                      :disabled="props.isDisable"
                    />
                  </div>
                </div>

                <div class="w-full">
                  <div
                    class="field"
                    style="flex: 1; min-width: 15rem; max-width: 21rem"
                    v-if="props.personType === 'vinculated'"
                  >
                    <label for="apodo" class="labelInput"> Apodo </label>
                    <InputText
                      v-no-emoji
                      class="input w-full"
                      placeholder="Apodo"
                      v-model="nickname"
                      :disabled="props.isDisable"
                      test-id="inputApodo"
                    />
                  </div>
                </div>

                <div class="w-full">
                  <label for="residencia" class="labelInput mb-3">Observación</label>
                  <Textarea
                    v-no-emoji
                    style="min-height: 150px"
                    class="input w-full mt-2"
                    type="text"
                    placeholder="Observaciones..."
                    v-model="observations"
                    :maxlength="250"
                    test-id="textareaDomResidencia"
                    :disabled="props.isDisable"
                  />
                </div>

                <div class="field col-12 md:col-3 sm:col-6" v-if="acusado">
                  <label for="nombre" class="labelInput" v-if="props.personType === 'vinculated'"
                    >Apodo</label
                  >
                  <InputText
                    v-no-emoji
                    class="input"
                    type="text"
                    placeholder="apodo"
                    v-model="nickname"
                    test-id="inputApodo"
                    :disabled="props.isDisable"
                  />
                  <label v-if="modifiedData.Apodo" :class="{ visible: errores.Apodo }">
                    {{ errores.Apodo }}
                  </label>
                </div>
              </div>

              <!-- PERSONA JURÍDICA -->
              <div class="p-fluid formgrid grid" v-if="juridicPerson" style="margin: 0">
                <div class="field col-12">
                  <h3>En representación de</h3>
                </div>

                <div class="p-fluid grid mb-3">
                  <!-- CUIT -->
                  <div class="col-12 md:col-4">
                    <label for="CUIT" class="labelInput">
                      CUIT
                      <span v-if="props.personType === 'affected'" style="color: red">*</span>
                    </label>
                    <InputText
                      v-no-emoji
                      class="input w-full"
                      type="number"
                      min="0"
                      placeholder="CUIT"
                      v-model="cuit"
                      :maxlength="50"
                      :disabled="props.isDisable"
                      test-id="inputCuit"
                    />
                    <label v-if="modifiedData.CUIT" :class="{ visible: errores.CUIT }">
                      {{ errores.CUIT }}
                    </label>
                  </div>

                  <!-- RAZÓN SOCIAL -->
                  <div class="col-12 md:col-4">
                    <label for="denominacion" class="labelInput">
                      Razón social
                      <span v-if="props.personType === 'affected'" style="color: red">*</span>
                    </label>
                    <InputText
                      v-no-emoji
                      class="input w-full"
                      type="text"
                      placeholder="Razón social"
                      v-model="companyName"
                      :maxlength="50"
                      :disabled="props.isDisable"
                      test-id="inputRsocial"
                    />
                    <label
                      v-if="modifiedData.Denominacion"
                      :class="{ visible: errores.Denominacion }"
                    >
                      {{ errores.Denominacion }}
                    </label>
                  </div>

                  <!-- DOMICILIO LEGAL -->
                  <div class="col-12 md:col-4">
                    <label for="domicilioJuridico" class="labelInput">
                      Domicilio legal
                      <span v-if="props.personType === 'affected'" style="color: red">*</span>
                    </label>
                    <InputText
                      v-no-emoji
                      class="input w-full"
                      type="text"
                      placeholder="Domicilio legal"
                      v-model="legalDomicile"
                      :maxlength="100"
                      :disabled="props.isDisable"
                      test-id="inputDomlegal"
                    />
                    <label
                      v-if="modifiedData.DomicilioJuridico"
                      :class="{ visible: errores.DomicilioJuridico }"
                    >
                      {{ errores.DomicilioJuridico }}
                    </label>
                  </div>
                </div>

                <div
                  class="field col-12 lg:col-4 md:col-6 sm:col-6"
                  style="padding-left: 0 !important"
                >
                  <label for="telefono" class="labelInput"
                    >Teléfono
                    <span v-if="props.personType === 'affected'" style="color: red">*</span></label
                  >
                  <InputText
                    v-no-emoji
                    class="input"
                    type="text"
                    placeholder="Teléfono"
                    v-model="juridicTelephone"
                    :maxlength="20"
                    :disabled="props.isDisable"
                    test-id="inputTeljuridico"
                  />
                  <label
                    v-if="modifiedData.TelefonoJuridico"
                    :class="{ visible: errores.TelefonoJuridico }"
                  >
                    {{ errores.TelefonoJuridico }}
                  </label>
                </div>

                <div
                  class="field col-12 lg:col-5 md:col-6 sm:col-6 mr-4"
                  style="width: 100%; max-width: 21rem; box-sizing: border-box"
                >
                  <label for="rubro" class="labelInput"
                    >Actividad
                    <span v-if="props.personType === 'affected'" style="color: red">*</span></label
                  >
                  <InputText
                    v-no-emoji
                    class="input"
                    type="text"
                    placeholder="Actividad"
                    v-model="activity"
                    :disabled="props.isDisable"
                    test-id="inputActividad"
                  />
                  <label v-if="modifiedData.Rubro" :class="{ visible: errores.Rubro }">
                    {{ errores.Rubro }}
                  </label>
                </div>

                <div class="mt-3 mr-6 pt-1" test-id="divTieneSeguro">
                  <Checkbox
                    class="mr-2 mt-3"
                    id="tiene-seguro"
                    v-model="insurance"
                    :binary="true"
                    :disabled="props.isDisable"
                  />
                  <label for="tiene-seguro" class="labelInput mt-8"><b>¿Tiene seguro?</b></label>
                </div>
              </div>
            </div>
            <CustomModal
              ref="personModalRef"
              :title="personModalData.title"
              :message="personModalData.message"
              :modalType="personModalData.modalType"
              :showSecondaryButton="personModalData.showSecondaryButton"
              :button-labels="personModalData.buttonLabels"
              @confirm="personModalData.onConfirm"
              @cancel="personModalData.onCancel"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, reactive, computed, watch } from "vue";
import InputMask from "primevue/inputmask";
import { onMounted } from "vue";
import { useRouterCompat } from "@/composables/useRouterCompat";
import { useNationalitiesStore } from "@/store/Pinia/useNacionalitiesStore";
import { useInstruccionStore } from "@/store/Pinia/useInstruccionStore";
import { useTypeSexStore } from "@/store/Pinia/useTypeSexStore";
import { useEstadoCivilStore } from "@/store/Pinia/useEstadoCivilStore";
import { useAllConditionsStore } from "@/store/Pinia/useAllConditionsStore";
import { useStoreCompat } from "@/composables/index";
import { useValidations } from "@/composables/useValidations";
import CustomTooltip from "@/components/CustomTooltip.vue";
import SearchModuleSIPE from "@/components/SearchModuleSIPE";
import { useIdentificationTypeStore } from "@/store/Pinia/useIdentificationTypeStore";
import { validateIdentificationByType } from "@/utils/validations/identification";
import generalFunctions from "@/store/modules/generalFunctions";

const { route } = useRouterCompat();
const flowKey = computed(() => route.query?.type || "");

const showOrdenPublico = computed(() => {
  const byViewData =
    viewData.value &&
    viewData.value.checkboxPublicOrder === true &&
    props.personType === "affected";

  const byFlow =
    props.isCreate === true &&
    flowKey.value &&
    (flowKey.value.includes("ufi") || flowKey.value.includes("oficio")) &&
    props.personType === "affected";

  return byViewData || byFlow;
});

const { emailErrors, validateEmail, calculateAge } = useValidations();
const documentType = ref(null);
const actuationType = ref("");
const acusado = ref(false);
const juridicPerson = ref(false);
const loadingSIPE = ref(false);
const nameValueRef = ref(null);
const surnameValueRef = ref(null);
const cuilValueRef = ref(null);
const birthdayValueRef = ref(null);
const domicileValueRef = ref(null);
const yearOldValueRef = ref(null);
const insuranceValueRef = ref(null);
const documentNumberValueRef = ref(null);
const telephoneValueRef = ref(null);
const emailValueRef = ref(null);
const professionValueRef = ref(null);
const nicknameValueRef = ref(null);
const observationsValueRef = ref(null);
const cuitValueRef = ref(null);
const companyNameValueRef = ref(null);
const legalDomicileValueRef = ref(null);
const juridicTelephoneValueRef = ref(null);
const activityValueRef = ref(null);
const telephoneInput = ref(null);
const sipeMode = ref(false);
const SIPEsearchUsed = ref(false);
const isSipeMode = ref(false);

const detenidoFiliacionTooltip =
  "No se puede asignar el tipo “Detenido” a personas con filiación desconocida. En estos casos, el tipo debe ser “Acusado”.";

const nationalitiesStore = useNationalitiesStore();
const instruccionStore = useInstruccionStore();
const typeSexStore = useTypeSexStore();
const estadoCivilStore = useEstadoCivilStore();
const conditionsStore = useAllConditionsStore();

const props = defineProps({
  personType: { type: String, default: "affected" },
  personData: { type: Object, default: () => ({}) },
  isDisable: { type: Boolean, default: false },
  isEdit: { type: Boolean, default: false },
  isCreate: { type: Boolean, default: false },
});

const emit = defineEmits(["updatePerson", "validationStatus", "setIsDisabled"]);

defineExpose({
  sipeMode,
  updateFormPersonaV2,
});

onMounted(async () => {
  if (!identificationTypeStore.identificationTypeListLoad) {
    await identificationTypeStore.setIdentificationType();
  }

  const viewData = store.getters["sumarioViews/getViewData"];
  const actuationTypeObj = viewData.actuationName;
  actuationType.value = Object.values(actuationTypeObj)[0];

  if (props?.personData?.Sexo !== undefined) {
    person.gender = {
      id: typeSexStore.getByNombre(props?.personData?.Sexo),
      nombre: props?.personData?.Sexo,
    };
  }
  if (props?.personData?.ExhibeDocumento !== undefined) {
    person.showDocument =
      props.personData.ExhibeDocumento === "1" ? { id: 1, nombre: "Sí" } : { id: 0, nombre: "No" };
  }
  if (props?.personData?.Nacionalidad !== undefined) {
    person.nacionality = {
      id: nationalitiesStore.getByNombre(props?.personData?.Nacionalidad),
      nombre: props?.personData?.Nacionalidad,
    };
  }
  if (props?.personData?.EstadoCivil !== undefined) {
    person.civilStatus = {
      id: nationalitiesStore.getByNombre(props?.personData?.EstadoCivil),
      nombre: props?.personData?.EstadoCivil,
    };
  }
  if (props?.personData?.TieneEstudios !== undefined) {
    person.haveStudies =
      props.personData.TieneEstudios === "1" ? { id: 1, nombre: "Sí" } : { id: 0, nombre: "No" };
  }
  if (props?.personData?.Instruccion !== undefined) {
    person.instruction = {
      id: nationalitiesStore.getByNombre(props?.personData?.Instruccion),
      nombre: props?.personData?.Instruccion,
    };
  }
  if (props?.personData?.TipoRolPersonaFisicaID !== undefined) {
    person.TipoRolPersonaFisicaID = {
      id: conditionsStore.getByNombre(props?.personData?.TipoRolPersonaFisicaID),
      nombre: props?.personData?.TipoRolPersonaFisicaID,
    };
  }
  if (
    props?.personData?.TipoDocumentoID !== undefined &&
    props?.personData?.TipoDocumentoID !== ""
  ) {
    const tipoDoc = tipoDocumentoList.value.find(
      (tipo) => tipo.id === props.personData.TipoDocumentoID
    );
    if (tipoDoc) {
      documentType.value = tipoDoc;
      person.tipoDocumento = tipoDoc;
    }
  }
  if (props?.personData?.Apellido === "Persona de Filiacion desconocida") {
    filiacionDesconocida.value = true;
  }
  if (props?.personData?.Apellido === "Orden público") {
    ordenPublico.value = true;
  }
  juridicPerson.value = isJuricPerson.value;
  await store.dispatch(
    "sumarioViews/setActuacionType",
    generalFunctions.translateNameFromFormType(resumen.value.formType)
  );
  initPersonFromFields();
});

const identificationTypeStore = useIdentificationTypeStore();
const tipoDocumentoList = computed(() => {
  return identificationTypeStore.identificationType.map((item) => ({
    id: item.id,
    nombre: item.name,
    descripcion: item.description,
  }));
});
const yesOrNoList = ref([
  { id: 1, nombre: "Sí" },
  { id: 0, nombre: "No" },
]);

const errores = reactive({ email: "", tipoDocumento: null, FechaDeNacimiento: null });
const modifiedData = reactive({ documento: false, fechaNacimiento: false });
const sexoList = computed(() => typeSexStore.sexo);
const nacionalityList = computed(() => nationalitiesStore.nacionalities);
const civilStatusList = computed(() => estadoCivilStore.estadoCivil);
const instruccionList = computed(() => instruccionStore.instrucciones);
const store = useStoreCompat();
const viewData = computed(() => store.getters["sumarioViews/getViewData"]);
const resumen = computed(() => store.getters["sumario/dataResumen"]);

const stylesFor720 = computed(() => {
  const is720 = window.innerWidth <= 1280;
  if (is720) {
    return { "margin-top": "1.2rem" };
  }

  return {};
});

let person = reactive({
  TipoRolPersonaFisicaID: null,
  personaJuridica: false,
  tipoDocumento: null,
  documento: "",
  gender: null,
  showDocument: null,
  cuil: "",
  error: "",
  apellido: "",
  nombre: "",
  edad: null,
  fechaNacimiento: "",
  nacionality: null,
  civilStatus: null,
  domicilio: "",
  vinculo: "",
  telefono: "",
  email: "",
  profesion: "",
  tieneEstudios: null,
  instruction: null,
  observaciones: "",
  apodo: "",
  cuit: "",
  denominacion: "",
  domicilioJuridico: "",
  telefonoJuridico: "",
  rubro: "",
  tieneSeguro: false,
  haveStudies: null,
  allPersonConditions: {
    condicionList: computed(() => store.state.siis.condicion),
    condicionCombinada: computed(() => store.state.siis.condicionCombinada),
    condicionPreliminar: computed(() => store.state.siis.condicionPreliminar),
    condicionCaidaCasual: computed(() => store.state.siis.condicionCaidaCasual),
    condicionUFIDenunciante: computed(() => store.state.siis.condicionUFIDenunciante),
    condicionUFIAcusado: computed(() => store.state.siis.condicionUFIAcusado),
    condicionUFIDenuncianteFallecido: computed(
      () => store.state.siis.condicionUFIDenuncianteFallecido
    ),
    condicionUFIDenuncianteParadero: computed(
      () => store.state.siis.condicionUFIDenuncianteParadero
    ),
    condicionUFIAcusadoParadero: computed(() => store.state.siis.condicionUFIAcusadoParadero),
    condicionTentativaSuicidio: computed(() => store.state.siis.condicionTentativaSuicidio),
    condicionSumarioAcusado: computed(() => store.state.siis.condicionSumarioAcusado),
    condicionContravencionAcusado: computed(() => store.state.siis.condicionContravencionAcusado),
    condicionAcusadoDetenido: computed(() => store.state.siis.condicionAcusadoDetenido),
    condicionPreliminarProcedencia: computed(() => store.state.siis.condicionPreliminarProcedencia),
  },
});

const isJuricPerson = computed(() => {
  const data = props.personData;
  const juridicFields = [
    data?.Cuit,
    data?.Denominacion,
    data?.DomicilioJuridico,
    data?.Rubro,
    data?.TelefonoJuridico,
  ];
  const hasData = juridicFields.some((value) => value && value !== "");
  const hasInsurance = data?.TieneSeguro === true || data?.TieneSeguro == "1";
  return hasData || hasInsurance;
});

const isADeterminar = computed(() => {
  const tipo = person.TipoRolPersonaFisicaID;
  if (!tipo) return false;

  return (
    tipo.nombre?.toLowerCase().trim() === "a determinar" ||
    tipo.id?.toLowerCase().trim() === "a determinar"
  );
});

const insurance = computed({
  get: () => {
    let value;
    if (insuranceValueRef.value != null) {
      value = insuranceValueRef.value;
    } else {
      value = props?.personData?.TieneSeguro === "1" ? true : false;
    }
    return value;
  },
  set: (value) => {
    insuranceValueRef.value = value;
  },
});

const yearOld = computed({
  get: () => {
    let value;
    if (yearOldValueRef.value != null) {
      value = yearOldValueRef.value;
    } else {
      value = calculateAge(props?.personData?.FechaDeNacimiento);
    }
    return value;
  },
  set: (value) => {
    yearOldValueRef.value = value;
  },
});

const surname = computed({
  get: () => {
    let value;
    if (surnameValueRef.value != null) {
      value = surnameValueRef.value;
    } else {
      value = props?.personData?.Apellido ? props?.personData?.Apellido : "";
    }
    return value;
  },
  set: (value) => {
    surnameValueRef.value = value;
  },
});

const name = computed({
  get: () => {
    let value;
    if (nameValueRef.value != null) {
      value = nameValueRef.value;
    } else {
      value = props?.personData?.Nombre ? props?.personData?.Nombre : "";
    }
    return value;
  },
  set: (value) => {
    nameValueRef.value = value;
  },
});

const birthday = computed({
  get: () => {
    let value;
    if (birthdayValueRef.value != null) {
      value = birthdayValueRef.value;
    } else {
      value = props?.personData?.FechaDeNacimiento ? props?.personData?.FechaDeNacimiento : "";
    }
    return value;
  },
  set: (value) => {
    let yerarsOldCalculated = calculateAge(value);
    if (yerarsOldCalculated !== NaN) yearOld.value = yerarsOldCalculated;
    birthdayValueRef.value = value;
  },
});

const documentNumber = computed({
  get: () => {
    let value;
    if (documentNumberValueRef.value != null) {
      value = documentNumberValueRef.value;
    } else {
      value = props?.personData?.NumeroIdentificacion || "";
    }
    return value;
  },
  set: (value) => {
    documentNumberValueRef.value = value;
  },
});

const cuil = computed({
  get: () => {
    let value;
    if (cuilValueRef.value != null) {
      value = cuilValueRef.value;
    } else {
      value = props?.personData?.Cuil ? props?.personData?.Cuil : "";
    }
    return value;
  },
  set: (value) => {
    cuilValueRef.value = value;
  },
});

const domicile = computed({
  get: () => {
    let value;
    if (domicileValueRef.value != null) {
      value = domicileValueRef.value;
    } else {
      value = props?.personData?.DomicilioSipe ? props.personData.DomicilioSipe : "";
    }
    return value;
  },
  set: (value) => {
    domicileValueRef.value = value;
  },
});

const telephone = computed({
  get: () => {
    let value;
    if (telephoneValueRef.value != null) {
      value = telephoneValueRef.value;
    } else {
      value = props?.personData?.Telefono ? props?.personData?.Telefono : "";
    }
    return value;
  },
  set: (value) => {
    const filteredTelephone = filterTelephone(value);
    // Previniendo a la fuerza que el usuario le ingrese valores alfanúmericos distintos a "+" o "-" o espacios
    telephoneInput.value.$el.value = filteredTelephone;
    telephoneValueRef.value = filteredTelephone;
  },
});

const email = computed({
  get: () => {
    let value;
    if (emailValueRef.value != null) {
      value = emailValueRef.value;
    } else {
      value = props?.personData?.Email ? props?.personData?.Email : "";
    }
    return value;
  },
  set: (value) => {
    emailValueRef.value = value;
  },
});

const profession = computed({
  get: () => {
    let value;
    if (professionValueRef.value != null) {
      value = professionValueRef.value;
    } else {
      value = props?.personData?.Profesion ? props?.personData?.Profesion : "";
    }
    return value;
  },
  set: (value) => {
    professionValueRef.value = value;
  },
});

const nickname = computed({
  get: () => {
    let value;
    if (nicknameValueRef.value != null) {
      value = nicknameValueRef.value;
    } else {
      value = props?.personData?.Apodo ? props?.personData?.Apodo : "";
    }
    return value;
  },
  set: (value) => {
    nicknameValueRef.value = value;
  },
});

const observations = computed({
  get: () => {
    let value;
    if (observationsValueRef.value != null) {
      value = observationsValueRef.value;
    } else {
      value = props?.personData?.Observaciones ? props?.personData?.Observaciones : "";
    }
    return value;
  },
  set: (value) => {
    observationsValueRef.value = value;
  },
});

const cuit = computed({
  get: () => {
    let value;
    if (cuitValueRef.value != null) {
      value = cuitValueRef.value;
    } else {
      value = props?.personData?.Cuit ? props?.personData?.Cuit : "";
    }
    return value;
  },
  set: (value) => {
    cuitValueRef.value = value;
  },
});

const companyName = computed({
  get: () => {
    let value;
    if (companyNameValueRef.value != null) {
      value = companyNameValueRef.value;
    } else {
      value = props?.personData?.Denominacion ? props?.personData?.Denominacion : "";
    }
    return value;
  },
  set: (value) => {
    companyNameValueRef.value = value;
  },
});

const legalDomicile = computed({
  get: () => {
    let value;
    if (legalDomicileValueRef.value != null) {
      value = legalDomicileValueRef.value;
    } else {
      value = props?.personData?.DomicilioJuridico ? props?.personData?.DomicilioJuridico : "";
    }
    return value;
  },
  set: (value) => {
    legalDomicileValueRef.value = value;
  },
});

const juridicTelephone = computed({
  get: () => {
    let value;
    if (juridicTelephoneValueRef.value != null) {
      value = juridicTelephoneValueRef.value;
    } else {
      value = props?.personData?.TelefonoJuridico ? props?.personData?.TelefonoJuridico : "";
    }
    return value;
  },
  set: (value) => {
    juridicTelephoneValueRef.value = value;
  },
});

const activity = computed({
  get: () => {
    let value;
    if (activityValueRef.value != null) {
      value = activityValueRef.value;
    } else {
      value = props?.personData?.Rubro ? props?.personData?.Rubro : "";
    }
    return value;
  },
  set: (value) => {
    activityValueRef.value = value;
  },
});

const filiacionDesconocida = ref(false);
const ordenPublico = ref(false);

const isDetenidoCondition = computed(() => {
  const condition = person.TipoRolPersonaFisicaID;
  if (!condition) return false;
  return condition.nombre === "Detenido" || condition.id === "Detenido";
});

const personModalData = ref({
  title: "",
  message: "",
  modalType: "",
  showSecondaryButton: true,
  buttonLabels: [],
  onConfirm: () => {},
  onCancel: () => {},
});

const showNotFoundModal = () => {
  personModalData.value = {
    title: "Persona no encontrada",
    message: "No se ha encontrado la persona buscada",
    modalType: "error",
    showSecondaryButton: false,
    onConfirm: () => {
      personModalRef.value?.close();
    },
    onCancel: () => {},
  };
  personModalRef.value?.open();
};

const showOfflineModal = () => {
  personModalData.value = {
    title: "SIPE sin conexión",
    message: "El servicio SIPE no responde o no hay conexión",
    modalType: "error",
    showSecondaryButton: false,
    onConfirm: () => {
      personModalRef.value?.close();
    },
    onCancel: () => {},
  };
  personModalRef.value?.open();
};

function validateIdentification(valor, requerido = true) {
  const tieneTipoDocumento = person.tipoDocumento && person.tipoDocumento !== null;

  // Si es vinculado y no tiene tipo de documento, no validar
  if (props.personType === "vinculated" && !tieneTipoDocumento) {
    errores.documento = null;
    return true;
  }

  // Si es afectado o vinculado con tipo de documento, y es requerido pero está vacío
  if (requerido && !valor) {
    errores.documento = "El campo documento es obligatorio.";
    return false;
  }

  // Si hay tipo de documento y valor, validar formato
  if (tieneTipoDocumento && valor) {
    const { valid, formattedValue, message } = validateIdentificationByType(
      person.tipoDocumento,
      valor
    );

    // Actualizar con el valor formateado si es diferente
    if (formattedValue !== undefined && formattedValue !== person.documento) {
      person.documento = formattedValue;
      documentNumber.value = formattedValue;
    }

    if (!valid) {
      errores.documento = message;
      return false;
    }
  }

  // Si pasó todas las validaciones
  if (
    (props.personType === "affected" && valor) ||
    (props.personType === "vinculated" && tieneTipoDocumento && valor)
  ) {
    errores.documento = null;
  }

  return true;
}

function updateFormPersonaV2(personToUpdate) {
  name.value = personToUpdate.name;
  surname.value = personToUpdate.surname;
  cuil.value = personToUpdate.cuil;
  birthday.value = personToUpdate.birthday;
  domicile.value = personToUpdate.domicile;
  yearOld.value = personToUpdate.yearOld;
  person.gender = personToUpdate.gender === undefined ? person.gender : personToUpdate.gender;
  documentNumber.value =
    personToUpdate?.documentNumber === undefined
      ? documentNumber.value
      : personToUpdate?.documentNumber;
  documentType.value =
    personToUpdate?.documentType === undefined ? documentType.value : personToUpdate?.documentType;
  person.nacionality =
    personToUpdate?.nacionality === undefined ? person.nacionality : personToUpdate?.nacionality;
}

function setIsDisabled(value) {
  emit("setIsDisabled", value);
}

function callToSIPEsearchUsed(value) {
  SIPEsearchUsed.value = value;
}

watch(documentType, (val) => {
  person.tipoDocumento = val;
  if (!val || val === null) {
    person.documento = "";
    documentNumber.value = "";
    errores.documento = null;
    errores.tipoDocumento = null;
    emit("validationStatus", errores);
    return;
  }
  // Validar documento existente cuando cambia el tipo
  const esRequerido = props.personType === "affected" || (val && val !== null);
  if (person.documento) {
    validateIdentification(person.documento, esRequerido);
    // Si hay documento, limpiar el error de tipoDocumento
    if (person.documento && person.documento.trim() !== "") {
      errores.tipoDocumento = null;
    }
  } else if (modifiedData.documento && props.personType === "affected" && !person.documento) {
    errores.documento = "El campo documento es obligatorio.";
  } else if (
    modifiedData.documento &&
    props.personType === "vinculated" &&
    val &&
    val !== null &&
    !person.documento
  ) {
    errores.documento = "El campo documento es obligatorio.";
  } else {
    errores.documento = null;
  }
  emit("validationStatus", errores);
});

watch(juridicPerson, (val) => (person.personaJuridica = val));

watch(
  () => person.TipoRolPersonaFisicaID,
  () => {
    if (isDetenidoCondition.value) {
      filiacionDesconocida.value = false;
    }
  }
);

watch(filiacionDesconocida, (val) => {
  if (isDetenidoCondition.value) {
    person.filiacionDesconocida = false;
    surname.value = "";
    emit("updatePerson", person);
    return;
  }

  if (val) {
    surname.value = "Persona de Filiacion desconocida";
    person.TipoRolPersonaFisicaID = { id: "Acusado", nombre: "Acusado" };
  } else {
    surname.value = "";
    person.TipoRolPersonaFisicaID = null;
  }
  person.filiacionDesconocida = val;
  emit("updatePerson", person);
});
watch(ordenPublico, (val) => {
  if (ordenPublico.value) {
    surname.value = "Orden público";
    if (generalFunctions.translateNameFromFormType(resumen.value.formType).includes("ufi")) {
      person.TipoRolPersonaFisicaID = { id: "Denunciante", nombre: "Denunciante" };
    } else {
      person.TipoRolPersonaFisicaID = { id: "Damnificado", nombre: "Damnificado" };
    }
  } else {
    surname.value = "";
    person.TipoRolPersonaFisicaID = null;
  }
  person.ordenPublico = val;
  emit("updatePerson", person);
});

watch(documentNumber, (val) => {
  modifiedData.documento = true;
  const tieneTipoDocumento = person.tipoDocumento && person.tipoDocumento !== null;
  const esRequerido = props.personType === "affected" || tieneTipoDocumento;
  validateIdentification(val, esRequerido);
  person.documento = val;
  // Para vinculado: si se ingresa documento, validar que tipoDocumento sea obligatorio
  if (props.personType === "vinculated" && val && val.trim() !== "") {
    if (!tieneTipoDocumento) {
      errores.tipoDocumento = "Campo obligatorio";
    }
  } else if (props.personType === "vinculated" && (!val || val.trim() === "")) {
    errores.tipoDocumento = null;
  }
  emit("validationStatus", errores);
});
watch(surname, (val) => (person.apellido = val));
watch(name, (val) => (person.nombre = val));
watch(yearOld, (val) => (person.edad = val));
const parseBirthDate = (value) => {
  if (typeof value !== "string" || !/^\d{2}\/\d{2}\/\d{4}$/.test(value)) return null;
  const [day, month, year] = value.split("/").map(Number);
  const parsed = new Date(year, month - 1, day);
  if (Number.isNaN(parsed.getTime())) return null;
  if (parsed.getFullYear() !== year || parsed.getMonth() !== month - 1 || parsed.getDate() !== day)
    return null;
  return parsed;
};

const validateBirthDate = (value) => {
  if (!value || value === "") return null;
  const isComplete = typeof value === "string" && /^\d{2}\/\d{2}\/\d{4}$/.test(value);
  if (!isComplete) {
    return /\d/.test(value) ? "Fecha incompleta" : null;
  }
  const parsed = parseBirthDate(value);
  if (!parsed) return "Fecha inválida";
  const today = new Date();
  const todayDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());
  if (parsed > todayDate) return "No se permiten fechas futuras";
  return null;
};

const onBirthdayInteraction = () => {
  modifiedData.fechaNacimiento = true;
  errores.FechaDeNacimiento = validateBirthDate(birthday.value);
};

watch(birthday, (val) => {
  person.fechaNacimiento = val;
  if (modifiedData.fechaNacimiento) {
    errores.FechaDeNacimiento = validateBirthDate(val);
  }
});
watch(cuil, (val) => (person.cuil = val));
watch(domicileValueRef, (val) => (person.domicilio = val));
watch(telephone, (val) => (person.telefono = val));
watch(email, (val) => {
  let validationPass = validateEmail(val);
  if (validationPass) person.email = val;
});
watch(profession, (val) => (person.profesion = val));
watch(nickname, (val) => (person.apodo = val));
watch(observations, (val) => (person.observaciones = val));
watch(cuit, (val) => (person.cuit = val));
watch(companyName, (val) => (person.denominacion = val));
watch(legalDomicile, (val) => (person.domicilioJuridico = val));
watch(juridicTelephone, (val) => (person.telefonoJuridico = val));
watch(activity, (val) => (person.rubro = val));

watch(insurance, (val) => (person.tieneSeguro = val));

watch(sipeMode, () => {
  documentType.value = null;
  documentNumber.value = null;
  person.gender = null;
  SIPEsearchUsed.value = false;
});

watch(
  person,
  (newVal) => {
    if (newVal?.TipoRolPersonaFisicaID?.nombre === "A Determinar") {
      clearExceptRole(person);
    }
    emit("updatePerson", person);
    emit("validationStatus", errores);
  },
  { deep: true },
  { immediate: true }
);

function filterTelephone(input) {
  if (!input) return "";
  // Elimina todo lo que NO sea dígito, +, - o espacio
  return input.replace(/[^0-9+\-\s]/g, "");
}

function clearExceptRole(obj) {
  for (const key in obj) {
    if (key === "TipoRolPersonaFisicaID" || key === "allPersonConditions") continue;

    obj[key] =
      typeof obj[key] === "string"
        ? ""
        : typeof obj[key] === "number"
          ? null
          : typeof obj[key] === "boolean"
            ? false
            : null;
  }
  surnameValueRef.value = "";
  nameValueRef.value = "";
  cuilValueRef.value = "";
  birthdayValueRef.value = "";
  domicileValueRef.value = "";
  yearOldValueRef.value = null;
  insuranceValueRef.value = false;
  documentNumberValueRef.value = "";
  telephoneValueRef.value = "";
  emailValueRef.value = "";
  professionValueRef.value = "";
  nicknameValueRef.value = "";
  observationsValueRef.value = "";
  cuitValueRef.value = "";
  companyNameValueRef.value = "";
  legalDomicileValueRef.value = "";
  juridicTelephoneValueRef.value = "";
  activityValueRef.value = "";
}

async function sipeSearch() {
  let data = {};
  try {
    loadingSIPE.value = true;
    const sexo = person.gender?.nombre === "Masculino" ? "M" : "F";
    const url = `${process.env.VUE_APP_BACKEND_ENVIRONMENT}/data-persona?dni=${documentNumber.value}&sexo=${sexo}`;
    const result = await fetch(url, { credentials: "include" });
    timer.value = true;

    data = await result.json();
  } catch (e) {
    const env = process.env.VUE_APP_BACKEND_ENVIRONMENT;
    if (
      env === "http://dev.electro3.com.ar/siis/api/v1" ||
      env === "http://localhost/siis/api/v1"
    ) {
      data = {
        sipe: {
          personaInfo: {
            ...SIPEexample.value[Math.round(Math.random())],
          },
          resultadoWS: {
            codigoError: "",
            exito: true,
            msgError: "",
          },
        },
      };
    } else {
      console.error("err", e);
      console.error("Datos incompletos o problema de conexión con SIPE.");
    }
  }

  if (data.sipe?.resultadoWS.exito !== true) {
    if (data.sipe && data.sipe.resultadoWS) {
      console.error("Persona no encontrada");
      showNotFoundModal();
    } else {
      console.error("SIPE sin conexión.");
      showOfflineModal();
    }
  } else {
    // Nombre y Apellido
    name.value = data.sipe.personaInfo.nombre;
    surname.value = data.sipe.personaInfo.apellido;
    cuil.value = data.sipe.personaInfo.cuil;
    // Fecha de nacimiento
    const dataDeNacimiento = data.sipe.personaInfo.fechaNacimiento;
    const orderedDate =
      dataDeNacimiento.slice(8, 10) +
      dataDeNacimiento.slice(4, 7) +
      "-" +
      dataDeNacimiento.slice(0, 4);

    birthday.value = orderedDate;

    // Domicilio
    const address = data.sipe.personaInfo.domicilios.domicilio[0];
    domicile.value = `${address.calle} ${address.numero}, ${address.barrio} CP:${address.cpostal} - ${address.municipio}, ${address.provincia}, ${address.pais}`;

    // Edad y actualización de campos
    const yearOldFromSIPE = calculateAge(birthday.value);
    yearOld.value = yearOldFromSIPE;
  }
  loadingSIPE.value = false;
}

function initPersonFromFields() {
  Object.assign(person, {
    tipoDocumento: documentType.value,
    personaJuridica: juridicPerson.value,
    filiacionDesconocida: filiacionDesconocida.value,
    ordenPublico: ordenPublico.value,
    documento: documentNumber.value,
    apellido: surname.value,
    nombre: name.value,
    edad: yearOld.value,
    fechaNacimiento: birthday.value,
    cuil: cuil.value,
    domicilio: domicile.value,
    telefono: telephone.value,
    email: email.value,
    profesion: profession.value,
    apodo: nickname.value,
    observaciones: observations.value,
    cuit: cuit.value,
    denominacion: companyName.value,
    domicilioJuridico: legalDomicile.value,
    telefonoJuridico: juridicTelephone.value,
    rubro: activity.value,
    tieneSeguro: insurance.value,
    // condicion: condition?.value ?? null,
  });
}
</script>

<style scoped>
.labelInput {
  color: #0b5195;
  font-size: 16px;
  font-weight: 400;
  font-family: "Inter", sans-serif;
}

.input {
  border: 1px solid #0b5195;
  border-radius: 6px;
  width: 100%;
  color: #9ca3af;
}

.input:focus {
  border: none !important;
}

.primaryButton {
  color: white;
  background-color: #0b5195;
}

.primaryButton:hover {
  background-color: #1366b0;
}

.button {
  min-width: 130px;
  min-height: 43px;
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  border: none;
  border-radius: 6px;
}

.error-slot {
  min-height: 1.25rem;
  margin-top: 4px;
}

.error-field {
  color: red;
  display: block;
  font-size: 0.8rem;
  line-height: 1.3;
  word-break: break-word;
  white-space: normal;
}

.filiacion-disabled-label {
  opacity: 0.5;
}

.custom-radio {
  display: inline-flex;
  align-items: center;
  cursor: pointer;
  font-weight: 600;
  color: #1d4d90;
  margin-right: 2rem;
  user-select: none;
  font-size: 15px;
}

.custom-radio input {
  display: none;
}

.custom-radio .radio {
  width: 26px;
  height: 26px;
  border: 2px solid #1d4d90;
  border-radius: 50%;
  margin-right: 10px;
  position: relative;
  flex-shrink: 0;
}

.custom-radio input:checked + .radio::after {
  content: "";
  width: 18px;
  height: 18px;
  background: #1d4d90;
  border-radius: 50%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>
